<!-- 书写解答题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select mb-10">
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="flex FlexBaseline">
                    <div>{{ subQuestionNum + 1 }}、</div>
                    <div class="topic_title" v-html="$Tools.handlerImg(topicInfo?.stem)" v-mathml></div>
                </div>
                <div class="mt-10" v-if="!(isShowScoring || topicInfo.showAnalysis)">
                    <quillEditor :model-value="topicInfo.doAnswer" @update:model-value="getAnswer"></quillEditor>
                </div>
            </div>
        </div>
        <!-- <div v-if="!testType">
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="top_answer p-20">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>得分：{{ topicInfo.studentScore }}</div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div>参考答案：</div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.answer)"></div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div class="user_answer">你的答案：
                            <div class="bg_line"></div>
                        </div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.doAnswer)"></div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div class="user_answer">老师批语：
                            <div class="bg_line bg_line_yellow"></div>
                        </div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.markerComment)"></div>
                    </div>
                </div>
            </div>
        </div> -->
        <div>
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="top_answer p-20">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>得分：{{ topicInfo.studentScore }}</div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div>参考答案：</div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.answer)" v-mathml></div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div class="user_answer">你的答案：
                            <div class="bg_line"></div>
                        </div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.doAnswer)" v-mathml></div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div class="user_answer">老师批语：
                            <div class="bg_line bg_line_yellow"></div>
                        </div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.markerComment)" v-mathml></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="marker_info" v-if="topicInfo.markerComment">
            <div class="marker_label mb-10">题目批语：</div>
            <div v-html="$Tools.handlerImg(topicInfo.markerComment)"></div>
        </div> -->
    </div>
</template>

<script>
import quillEditor from "@/components/quillEditor/index.vue"
import { mapState } from "vuex";
export default {
    name: "GjkcH5Choice",
    components: { quillEditor },
    props: {
        questionInfo: {},
        disabled: {},
        subQuestionNum: {},
        isShowScoring: {
            default: false,
        },
        testType: {}, // 区分闯关，为1时是闯关,
    showAnswer:{}, // 用于测评报告弹题展示解析等
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
        }),
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        // this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                }
            },
            deep: true,
            immediate: true
        },
    },

    mounted() { },

    methods: {
        // 富文本获取内容
        getAnswer(info) {
            // console.log(info,33333333);
            this.topicInfo.doAnswer = info;
            // this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer;   // 保存答案
            // this.topicInfo.questionContext.isFinish = true;   // 是否已完成
            this.$emit('answerQuestion', this.topicInfo);
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {
        // overflow-x: auto;

        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    // padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .top_answer {
        background: #F8F9FA;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;

        .user_answer {
            position: relative;

            .bg_line {
                width: 73px;
                height: 8px;
                background: rgba(19, 214, 170, 0.2);
                position: absolute;
                top: 16px;
                left: 0;
            }

            .bg_line_yellow {
                background: rgba(255, 145, 0, 0.2);
            }
        }
    }

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }

        .get_score {
            color: #FD673B;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}

.marker_info {
    width: 100%;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;

    .marker_label {
        font-size: 14px;
        color: #999999;
    }
}
</style>